"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _auth = require("@/utils/auth");
var _validate = require("@/utils/validate");
var _index = require("@/utils/index");
var _elementUi = require("element-ui");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { JSEncrypt } from 'jsencrypt'
var _default = exports.default = {
  name: 'SsoRedirect',
  data: function data() {
    return {
      isSelectRoles: false,
      role: '',
      roleList: [],
      token: '',
      sasToken: '',
      errorKeys: [],
      errorInfo: {},
      loading: false
    };
  },
  mounted: function mounted() {
    if ((0, _validate.isMobile)()) {
      // 移动端（app内打开的跳转页）
      this.handleAppInit();
    } else {
      // pc端
      this.init();
    }
  },
  methods: {
    getRoleName: _index.getRoleName,
    handleAppInit: function handleAppInit() {
      try {
        var key = window.location.href.split('?token=')[1] || '';
        window.location.href = 'goodyear-sfe://success?token=' + key;
      } catch (error) {
        console.log(error);
      }
    },
    init: function init() {
      var _this = this;
      var key = window.location.href.split('?token=')[1] || '';
      if (!key) {
        _elementUi.MessageBox.confirm(this.$t('login.redirectError'), this.$t('common.tip'), {
          confirmButtonText: this.$t('login.backToLogin'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this.$store.dispatch('user/resetToken').then(function () {
            _this.$router.push({
              path: '/login'
            });
          });
        }).catch(function () {
          console.log('cancel');
        });
        return;
      }
      this.loading = true;
      this.$api.login.ssoLogin({
        token: decodeURIComponent(key),
        loginPlatform: 'PC'
      }).then(function (res) {
        _this.token = res.data.token;
        _this.sasToken = res.data.sasToken;
        var expiredTime = (new Date().getTime() + 15 * 60 * 1000).toString();
        _this.$store.dispatch('user/setSasTokenExpiredTime', expiredTime);
        _this.$store.dispatch('user/setInfo', res.data);
        _this.$store.dispatch('user/setSystemList', [{
          systemName: 'SFE管理后台',
          appIdentification: 'sfe'
        }]);
        _this.currentSystem = {
          systemName: 'SFE管理后台',
          appIdentification: 'sfe'
        };
        _this.role = res.data.roleCodes[0];
        _this.roleList = res.data.roleCodes;
        if (res.data.roleCodes.length === 1) {
          _this.changeRole();
        } else {
          // 弹框提示选择角色
          _this.isSelectRoles = true;
        }
        _this.loading = false;
        // this.loading = false

        // this.$store.dispatch('user/setToken', res.data.token)
        // this.$store.dispatch('user/setInfo', res.data.currUser)
        // this.$store.dispatch('user/setSystemList', res.data.systemInfos)

        // this.currentSystem = res.data.systemInfos[0]
        // this.singleSystemLogin(res.data.systemInfos[0].appIdentification)
      }).catch(function () {
        _this.loading = false;
        _this.$router.push({
          path: '/login'
        });
      });
    },
    backToLogin: function backToLogin() {
      this.isSelectRoles = false;
      (0, _auth.removeToken)();
      this.$router.push({
        path: '/login'
      });
    },
    changeRole: function changeRole() {
      var _this2 = this;
      var param = {
        roleCode: this.role
      };
      if (this.role == "Leadership") {
        this.$message.error(this.$t('navbar.changeRole_noPermission'));
        return;
      }
      this.$api.login.sfeChangeRole(param, this.token).then(function (res) {
        if (res.data.menus && res.data.menus.length) {
          // 有菜单可以访问
          _this2.$store.dispatch('user/setRoles', [_this2.role]);
          _this2.$store.dispatch('user/setTeamType', res.data.teamType);
          _this2.$store.dispatch('user/setToken', _this2.token);
          _this2.$store.dispatch('user/setSasToken', _this2.sasToken);
          _this2.$store.dispatch('user/setCurrentSystemInfo', _this2.currentSystem);
          _this2.$store.dispatch('nocache/setAddRoute', {
            isAddRoute: true
          });
          _this2.$store.dispatch('permission/generateRoutes', res.data.menus).then(function (res) {
            _this2.$router.push({
              path: '/dashboard'
            });
          });
          _this2.$store.dispatch('permission/generateFunctions', res.data.functions);
        } else {
          // 没有菜单可以访问
          _this2.$message.error(_this2.$t('navbar.changeRole_noPermission'));
        }
      });
    }
  }
};